import produce from 'immer';
import {
    GET_PLAN_TYPE_LIST, GET_USER_FARM_LIST_REQUEST, GET_USER_FARM_LIST,
    GET_FARM_LIST_REQUEST, GET_FARM_LIST, SET_CURRENT_FARM,
    GET_TIMEZONE_LIST, GET_FARM_ENTITY_INFO, GET_FARM_ENTITY_INFO_REQUEST,
    SET_FARM_ADDRESS, FARM_ADDRESS_SAVING, GET_FARM_STATS_FIELD, GET_FARM_STATS_FIELD_REQUESTING, SET_FARM_SETTINGS,
    GET_FARM_USERS_LIST_REQUEST, GET_FARM_USERS_LIST, UPDATE_CURRENT_FARM
} from '../constants/action-types';
import { setFarmInfo } from '../helpers/session';

const initialState = {
    currentFarm: {},
    isRequesting: false,
    userFarmList: [],
    farmList: [],
    farmEntityInfo: {},
    timeZoneList: [],
    planTypeList: [],
    farmAddress: {},
    farmSettings: {},
    isSaving: false,
    farmStatsField: {
        isRequesting: false,
        payload: {}
    },
    farmUsersList: {
        isRequesting: false,
        payload: []
    }
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_PLAN_TYPE_LIST:
            state = { ...state, planTypeList: action.payload ? action.payload : initialState.planTypeList };
            break;
        case GET_USER_FARM_LIST_REQUEST:
            state = { ...state, isRequesting: true, userFarmList: [] };
            break;
        case GET_USER_FARM_LIST:
            state = { ...state, userFarmList: action.payload ? action.payload : initialState.userFarmList, isRequesting: false };
            break;
        case GET_FARM_LIST_REQUEST:
            state = { ...state, isRequesting: true, farmList: [] };
            break;
        case GET_FARM_LIST:
            state = { ...state, farmList: action.payload ? action.payload : initialState.farmList, isRequesting: false };
            break;
        case GET_TIMEZONE_LIST:
            state = { ...state, timeZoneList: action.payload ? action.payload : initialState.timeZoneList };
            break;
        case SET_CURRENT_FARM:
            setFarmInfo(action.payload ? action.payload : initialState.currentFarm);
            state = { ...state, currentFarm: action.payload ? action.payload : initialState.currentFarm };
            break;
        case UPDATE_CURRENT_FARM:
            setFarmInfo(action.payload ? action.payload : initialState.currentFarm);
            state = { ...state, currentFarm: { ...state.currentFarm, ...action.payload } };
            break;
        case GET_FARM_ENTITY_INFO_REQUEST:
            state = produce(state, s => {
                s.farmEntityInfo = initialState.farmEntityInfo;
            });
            break;
        case GET_FARM_ENTITY_INFO:
            state = produce(state, s => {
                s.farmEntityInfo = action.payload ? action.payload : initialState.farmEntityInfo;
            });
            break;
        case SET_FARM_ADDRESS:
            state = produce(state, s => {
                s.farmAddress = action.payload ? action.payload : initialState.farmAddress;
            });
            break;
        case SET_FARM_SETTINGS:
            state = produce(state, s => {
                s.farmSettings = action.payload ? action.payload : initialState.farmSettings;
            });
            break;
        case FARM_ADDRESS_SAVING:
            state = produce(state, s => {
                s.isSaving = action.payload;
            });
            break;
        case GET_FARM_STATS_FIELD_REQUESTING:
            state = produce(state, s => {
                s.farmStatsField = {
                    isRequesting: true,
                    payload: {}
                }
            });
            break;
        case GET_FARM_STATS_FIELD:
            state = {
                ...state,
                farmStatsField: {
                    isRequesting: false,
                    payload: action.payload ? { ...state.farmStatsField.payload, ...action.payload } : {}
                }
            }
            break;
        case GET_FARM_USERS_LIST_REQUEST:
            state = produce(state, s => {
                s.farmUsersList = {
                    isRequesting: true,
                    payload: []
                }
            });
            break;
        case GET_FARM_USERS_LIST:
            state = {
                ...state,
                farmUsersList: {
                    isRequesting: false,
                    payload: action.payload ? action.payload : []
                }
            }
            break;
        default:
            break;
    }

    return state;
}